<template>
  <QuadroPrincipal titulo="CRÉDITO PRESUMIDO" :classe="classe">
    <Registro paddingSemCheckBox>
      <Cabecalho titulo="Crédito Presumido" />
      <div class="separador" />

      <Ncm v-if="registro.ncm" :ncm="registro.ncm" />
      <div v-if="registro.ncm" class="separador" />

      <Descricao :titulo="'Descrição'" :descricao="registro.descricao" />

      <div class="sub-registro-container">
        <SubRegistro :classe="classe">
          <Cabecalho :titulo="'PIS'" />
          <div class="separador" />
          <Cabecalho
            v-if="registro.perc_credito_pis"
            tipo="link"
            :titulo="'Percentual de Crédito PIS'"
            :aliquota="creditoPis"
          />
          <div v-if="registro.perc_credito_pis" class="separador" />
          <BaseLegal
            v-if="registro.base_legal_red_pis"
            :base_legal="registro.base_legal_red_pis"
            :classe="classe"
          />
        </SubRegistro>

        <SubRegistro :classe="classe">
          <Cabecalho :titulo="'COFINS'" />
          <div class="separador" />
          <Cabecalho
            v-if="registro.perc_credito_cofins"
            tipo="link"
            :titulo="'Percentual de Crédito COFINS'"
            :aliquota="creditoCofins"
          />
          <div v-if="registro.perc_credito_cofins" class="separador" />
          <BaseLegal
            v-if="registro.base_legal_red_cofins"
            :base_legal="registro.base_legal_red_cofins"
            :classe="classe"
          />
        </SubRegistro>
      </div>
      <div>
        <Notificacao v-if="registro.alerta" :tipo="'alerta'" :texto="registro.alerta" />
        <Notificacao
          v-if="registro.obs_aplic"
          :tipo="'aplicabilidade'"
          :texto="registro.obs_aplic"
        />
        <Notificacao
          v-if="registro.obs_inaplic"
          :tipo="'inaplicabilidade'"
          :texto="registro.obs_inaplic"
        />
        <Notificacao v-if="registro.obs" :tipo="'observação'" :texto="registro.obs" />
        <Notificacao v-if="registro.nota" :tipo="'nota'" :texto="registro.nota" />
      </div>
    </Registro>
  </QuadroPrincipal>
</template>

<script>
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";
import BaseLegal from "@/components/BaseLegal/BaseLegal.vue";
import Cabecalho from "@/components/Cabecalho/Cabecalho.vue";
import Descricao from "@/components/Descricao/Descricao.vue";
import Ncm from "@/components/Ncm/Ncm.vue";
import Notificacao from "@/components/Notificacao/Notificacao.vue";
import Registro from "@/components/Registro/Registro.vue";
import SubRegistro from "@/components/SubRegistro/SubRegistro.vue";

import stringFormatMixin from "@/mixins/stringFormatMixin";

export default {
  name: "QuadroCreditoPresumido",

  mixins: [stringFormatMixin],

  props: { registro: Object, classe: String },

  components: {
    QuadroPrincipal,
    BaseLegal,
    Cabecalho,
    Descricao,
    Notificacao,
    Registro,
    SubRegistro,
    Ncm
  },

  data() {
    return {};
  },
  computed: {
    creditoPis() {
      let credito =
        this.registro.perc_credito_pis != "-"
          ? `${this.registro.tipo_red_pis}&nbsp<b>${this.formatPercentFixed(
              this.registro.perc_credito_pis,
              4
            )}</b>&nbspsobre ${this.artigo(
              this.registro.perc_credito_base_calc_pis
            )} ${this.registro.perc_credito_base_calc_pis.toLowerCase()}`
          : `Sobre ${this.artigo(
              this.registro.perc_credito_base_calc_pis
            )} ${this.registro.perc_credito_base_calc_pis.toLowerCase()}`;
      return credito;
    },
    creditoCofins() {
      let credito =
        this.registro.perc_credito_cofins != "-"
          ? `${this.registro.tipo_red_cofins}&nbsp<b>${this.formatPercentFixed(
              this.registro.perc_credito_cofins,
              4
            )}</b>&nbspsobre ${this.artigo(
              this.registro.perc_credito_base_calc_cofins
            )} ${this.registro.perc_credito_base_calc_cofins.toLowerCase()}`
          : `Sobre ${this.artigo(
              this.registro.perc_credito_base_calc_cofins
            )} ${this.registro.perc_credito_base_calc_cofins.toLowerCase()}`;
      return credito;
    }
  },
  methods: {
    artigo(valor) {
      if (valor.includes("Custo") || valor.includes("Valor")) {
        return "o";
      }
      if (valor.includes("Receita")) {
        return "a";
      }
      return "";
    }
  }
};
</script>

<style lang="scss" scoped>
.sub-registro-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
</style>
